import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function AfterSchoolHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-648">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-649">
        After-School Activities in Farmington Hills
      </div>
      <div className="mb-8" data-id="element-650">
        <SocialProofBar data-id="element-651" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-652">
        After-School Kids Activities That Build Confidence
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-653">
        Storm Taekwondo gives kids an active, structured after-school activity
        that teaches focus, discipline, respect, goal setting and resilience.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-654">
        {['Respect for teachers, parents, and peers', 'How to follow multi-step instructions', 'Physical coordination and balance', 'Basic self-defense fundamentals'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-655">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-656" />
            <span data-id="element-657">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-658">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-659">
          Claim Your Child's Free Week
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-660">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-661" />
    </div>;
}